export default [
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<h3>Чехол для iPhone 6 Plus, объёмная печать</h3><p>Чехол изготавливается из трёх материалов на выбор: пластик с покрытием soft touch, премиум эко-кожа или силикон.</p><p>Размеры: 160х80 мм.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `<p>Объёмная печать выполняется на американском оборудовании с использованием уникальных "гибких" чернил. Принт наносится на поверхность чехла в три слоя за один проход, что позволяет максимально быстро выполнять даже самые большие тиражи. Завершает процесс печати - покрытие поверхности специальным лаком, который придает глянцевый эффект изображению.</p><p>Высота подъёма чернил может варьироваться от 1 до 2,5 мм.</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
